import {CheckboxItemComponent} from './checkbox.item.component';
import {CheckboxButtonComponent} from './checkbox.button.component';
import {ICheckBoxDirective} from '../icheckbox/i.checkbox.directive';

export const CHECKBOX_DIRECTIVES = [
    CheckboxButtonComponent,
    CheckboxItemComponent,
    ICheckBoxDirective
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/checkbox/index.ts